import { HighlightStyle, syntaxHighlighting } from '@codemirror/language'
import { EditorView } from '@codemirror/view'
import { tags } from '@lezer/highlight'

export const customHighlightStyle = syntaxHighlighting(
  HighlightStyle.define([
    {
      tag: tags.heading,
      color: 'inherit',
      fontWeight: 'bold'
    },
    { tag: tags.strong, fontWeight: 'bold' },
    { tag: tags.emphasis, fontStyle: 'italic' },
    {
      tag: tags.link,
      color: 'var(--color-contentColorPrimary)'
    },
    {
      tag: tags.list,
      color: 'var(--color-contentFuchsia)'
    },
    {
      tag: tags.quote,
      color: 'var(--color-contentLime)'
    },

    { tag: tags.tagName, color: 'var(--color-contentEmerald)' }, // u, sup, Button ...
    { tag: tags.attributeName, color: 'var(--color-contentAmber)' }, // src, href ...
    { tag: tags.angleBracket, color: 'var(--color-contentEmerald)' }, // <  >
    { tag: tags.literal, color: 'var(--color-contentSecondary)' } // props content
  ])
)

const commonStyles = {
  '&': {
    fontFamily: "Consolas, 'Fira Code', monospace",
    fontSize: '15px',
    outline: 'none !important'
  },
  '.cm-scroller': {
    backgroundColor: 'var(--color-backgroundSecondary)',
    color: 'var(--color-contentPrimary)',
    lineHeight: '22px',
    scrollbarWidth: 'thin'
  },
  '.cm-gutters': {
    border: 'none',
    fontSize: '14px',
    lineHeight: '22px',
    display: 'flex',
    justifyContent: 'flex-start',
    backgroundColor: 'var(--color-backgroundSecondary)',
    color: 'var(--color-contentInverseTertiary)'
  },
  '.cm-gutter': {
    justifyContent: 'flex-start !important'
  },
  '.cm-foldGutter': {
    display: 'none !important'
  },
  '.cm-gutterElement': {
    textAlign: 'left !important',
    padding: '0 0 0 4px !important',
    justifyContent: 'flex-start !important'
  },
  '.cm-line': {
    padding: '0 4px'
  },
  '.cm-selectionBackground, .cm-content ::selection': {
    backgroundColor: '#2563eb66 !important',
    zIndex: '1 !important'
  },
  '.cm-selectionMatch': {
    backgroundColor: '#2563eb66 !important'
  },

  // codemirror merge diff view
  '.cm-deletedChunk': {
    position: 'relative',
    backgroundColor: '#450a0a60'
  },
  // first line diff in the same line
  '.cm-deletedChunk:first-child .cm-chunkButtons': {
    top: '0',
    transform: 'translateY(-100%)',
    marginTop: '22px'
  },
  '.cm-chunkButtons': {
    top: '-24px'
  },
  '.cm-deletedChunk button[name=accept]': {
    backgroundColor: 'var(--color-backgroundGreen)',
    color: 'var(--color-contentGreen)',
    padding: '0 8px',
    borderRadius: '4px'
  },
  '.cm-deletedChunk button[name=reject]': {
    backgroundColor: 'var(--color-backgroundRed)',
    color: 'var(--color-contentRed)',
    padding: '0 8px',
    borderRadius: '4px'
  },
  '.cm-deletedLineGutter': {
    backgroundColor: 'var(--color-contentRed)'
  },
  '.cm-changedLineGutter': {
    backgroundColor: 'var(--color-contentGreen) !important'
  }
}

export const darkTheme = EditorView.theme(
  {
    ...commonStyles,
    '.cm-scroller': {
      ...commonStyles['.cm-scroller'],
      scrollbarColor: 'var(--color-contentSecondary) transparent'
    },
    '.cm-activeLineGutter': {
      backgroundColor: '#02061770'
    },
    '.cm-activeLine': {
      background: 'linear-gradient(90deg, #02061770, #02061770) !important',
      backgroundColor: 'transparent !important'
    },
    '.cm-activeLine .cm-selectionBackground, .cm-activeLine.cm-line ::selection': {
      backgroundColor: '#3b82f6 !important',
      zIndex: '2 !important'
    },
    // merge diff view
    '.cm-deletedChunk': {
      ...commonStyles['.cm-deletedChunk'],
      backgroundColor: '#450a0a60'
    },
    '.cm-changedLine': {
      backgroundColor: '#052e1660 !important'
    }
  },
  { dark: true }
)

export const lightTheme = EditorView.theme(
  {
    ...commonStyles,
    '.cm-scroller': {
      ...commonStyles['.cm-scroller'],
      scrollbarColor: '#a1a1a1 transparent'
    },
    '.cm-activeLineGutter': {
      backgroundColor: '#dce1e680'
    },
    '.cm-activeLine': {
      background: 'linear-gradient(90deg, #dce1e680, #dce1e680) !important',
      backgroundColor: 'transparent !important'
    },
    '.cm-activeLine .cm-selectionBackground, .cm-activeLine.cm-line ::selection': {
      backgroundColor: '#93c5fd !important',
      zIndex: '2 !important'
    },
    // merge diff view
    '.cm-deletedChunk': {
      ...commonStyles['.cm-deletedChunk'],
      backgroundColor: '#fee2e280'
    },
    '.cm-changedLine': {
      backgroundColor: '#dcfce780 !important'
    }
  },
  { dark: false }
)
